import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles,} from '@webs/components-library/theming';
import {ifDefined} from 'lit/directives/if-defined.js';

@customElement('webs-cta-big')
export class CtaBig extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      :host{
        --default-paragraph-size: 1rem;
      }

      @keyframes animation {
        0% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
      }

      .wrapper {
        position: relative;

        --default-paragraph-size: 1.05rem;
      }

      .m-cta-big--with-grid webs-grid-row {
        position: relative;
      }

      .m-cta-big .cta-actions {
        padding-top: 1.6rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 -.5rem -.55rem;
      }

      .cta-actions {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        margin: 1.6rem -.5rem 0;
      }

      .cta-actions ::slotted(*) {
        margin: 0 .5rem .55rem;
      }

      .m-cta-big .image-background {

        z-index: 0;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }

      .m-cta-big .image-background img {
            height: 100%;
            object-fit: cover;
            object-position: center;
            width: 100%;
        }

      .m-cta-big .text-content {
        position:relative;
        max-width: 895px;
        margin: 0 auto;
        z-index: 10;
      }

      .m-cta-big ::slotted(*) {
        font-weight: var(--font-weight-light);
        text-align: center !important;
        color: var(--color-white) !important;
      }

      .m-cta-big .text-content ::slotted(*){
        max-width: 704px;
        margin: 1.65rem auto 0;
        text-align: center;
      }

      .m-cta-big--with-grid .wrapper {
        border-radius: 16px;
        overflow: hidden;
      }

      .m-cta-big .wrapper {
        padding: 4rem 0;
        position: relative;
      }

      .m-cta-big .image-background::after {
        background: rgba(11, 15, 23, 0.3);
        content: '';
        height: 100%;
        position: absolute;
        width:100%;
        top: 0;
        left: 0;
        bottom: 0;
      }

      .bg-gradient .text-content ::slotted(*) {
        color: var(--color-white);
      }

      .rich-text-container--intro {
        margin-top: 1.6rem;
      }

      .rich-text-container--intro ::slotted(*) {
        font-family: var(--font-family-alternative);
        font-size: 1rem;
        font-weight: var(--font-weight-base);
      }

      .bg {
        background: radial-gradient(98.06% 313.37% at 1.94% 126.42%, #FF0DE6 5.73%, #FF2FA8 16.15%, #FF4383 27.08%, #FF5C55 45.35%, #FF7527 68.48%, #FF8A00 98.59%);
        background-size: cover;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }

      @media only screen and (min-width: 992px) {
        :host{
          --default-paragraph-size: 1.2rem;
        }

        .m-cta-big .wrapper {
          padding: 4.3rem 0 4.6rem;
        }

        .m-cta-big.title-big ::slotted([slot="title"]) {
          font-size: 3.6rem !important;
        }


        // .bg-1 {
        //   background-image: url("data:image/svg+xml,%3Csvg  viewBox='0 0 1440 400' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_605_10327' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='1440' height='400'%3E%3Crect width='1440' height='400' fill='url(%23paint0_linear_605_10327)'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_605_10327)'%3E%3Crect width='1440' height='400' fill='url(%23paint1_linear_605_10327)'/%3E%3Cg filter='url(%23filter0_f_605_10327)'%3E%3Cellipse cx='-74.9167' cy='-199.5' rx='332.083' ry='399.5' fill='url(%23paint2_radial_605_10327)'/%3E%3C/g%3E%3Cg filter='url(%23filter1_f_605_10327)'%3E%3Cellipse cx='-36.5' cy='-287' rx='376.5' ry='441' fill='%23FF00FF'/%3E%3C/g%3E%3Cg filter='url(%23filter2_f_605_10327)'%3E%3Cellipse cx='790.93' cy='-54.8293' rx='231.597' ry='223.171' fill='%23FF8A00'/%3E%3C/g%3E%3Cg filter='url(%23filter3_f_605_10327)'%3E%3Cellipse cx='862.79' cy='-140.837' rx='190.625' ry='223.171' fill='url(%23paint3_radial_605_10327)'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_f_605_10327' x='-707' y='-899' width='1264.17' height='1399' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10327'/%3E%3C/filter%3E%3Cfilter id='filter1_f_605_10327' x='-703' y='-1018' width='1333' height='1462' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='145' result='effect1_foregroundBlur_605_10327'/%3E%3C/filter%3E%3Cfilter id='filter2_f_605_10327' x='259.333' y='-578' width='1063.19' height='1046.34' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10327'/%3E%3C/filter%3E%3Cfilter id='filter3_f_605_10327' x='372.165' y='-664.008' width='981.25' height='1046.34' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10327'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_605_10327' x1='1440.26' y1='-34.8486' x2='993.719' y2='968.4' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF8A00'/%3E%3Cstop offset='1' stop-color='%23FF00FF'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_605_10327' x1='1815.95' y1='-18.6046' x2='1645.59' y2='813.222' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.28766' stop-color='%23FF8A00'/%3E%3Cstop offset='1' stop-color='%23FF00FF'/%3E%3C/linearGradient%3E%3CradialGradient id='paint2_radial_605_10327' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(-76.1421 -198.026) rotate(89.8236) scale(398.028 330.861)'%3E%3Cstop stop-color='%23FF00FF'/%3E%3Cstop offset='0.734375' stop-color='%23FF8A00'/%3E%3C/radialGradient%3E%3CradialGradient id='paint3_radial_605_10327' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(862.087 -140.014) rotate(89.8187) scale(222.348 189.923)'%3E%3Cstop stop-color='%23FF00FF'/%3E%3Cstop offset='0.734375' stop-color='%23FF8A00'/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E");
        //   opacity: 1;
        // }
        //
        // .bg-2 {
        //   background-image: url("data:image/svg+xml,%3Csvg width='1440' height='400' viewBox='0 0 1440 400' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_605_10281' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='1440' height='400'%3E%3Crect width='1440' height='400' fill='url(%23paint0_linear_605_10281)'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_605_10281)'%3E%3Crect width='1440' height='400' fill='url(%23paint1_linear_605_10281)'/%3E%3Cg filter='url(%23filter0_f_605_10281)'%3E%3Cellipse cx='1347.75' cy='-60.8361' rx='228.75' ry='223.171' fill='url(%23paint2_radial_605_10281)'/%3E%3C/g%3E%3Cg filter='url(%23filter1_f_605_10281)'%3E%3Cellipse cx='485.5' cy='-147.5' rx='281.5' ry='274.5' fill='%23FF00FF'/%3E%3C/g%3E%3Cg filter='url(%23filter2_f_605_10281)'%3E%3Cellipse cx='1070.92' cy='-60.8293' rx='277.917' ry='223.171' fill='%23FF8A00'/%3E%3C/g%3E%3Cg filter='url(%23filter3_f_605_10281)'%3E%3Ccircle cx='-132' cy='84' r='394' fill='%23FF8A00'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_f_605_10281' x='819' y='-584.007' width='1057.5' height='1046.34' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10281'/%3E%3C/filter%3E%3Cfilter id='filter1_f_605_10281' x='-86' y='-712' width='1143' height='1129' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='145' result='effect1_foregroundBlur_605_10281'/%3E%3C/filter%3E%3Cfilter id='filter2_f_605_10281' x='493' y='-584' width='1155.83' height='1046.34' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10281'/%3E%3C/filter%3E%3Cfilter id='filter3_f_605_10281' x='-826' y='-610' width='1388' height='1388' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10281'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_605_10281' x1='1440.26' y1='-34.8486' x2='993.719' y2='968.4' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF8A00'/%3E%3Cstop offset='1' stop-color='%23FF00FF'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_605_10281' x1='1815.95' y1='-18.6046' x2='1645.59' y2='813.222' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.28766' stop-color='%23FF8A00'/%3E%3Cstop offset='1' stop-color='%23FF00FF'/%3E%3C/linearGradient%3E%3CradialGradient id='paint2_radial_605_10281' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(1346.91 -60.0126) rotate(89.7825) scale(222.349 227.907)'%3E%3Cstop stop-color='%23FF00FF'/%3E%3Cstop offset='0.734375' stop-color='%23FF8A00'/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E");
        //   opacity: 0;
        // }
        //
        // .bg-3 {
        //   background-image: url("data:image/svg+xml,%3Csvg width='1440' height='400' viewBox='0 0 1440 400' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_605_10249' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='1440' height='400'%3E%3Crect width='1440' height='400' fill='url(%23paint0_linear_605_10249)'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_605_10249)'%3E%3Crect width='1440' height='400' fill='url(%23paint1_linear_605_10249)'/%3E%3Cg filter='url(%23filter0_f_605_10249)'%3E%3Ccircle cx='792.5' cy='699.5' r='575.5' fill='%23FF8A00'/%3E%3C/g%3E%3Cg filter='url(%23filter1_f_605_10249)'%3E%3Cellipse cx='912.5' cy='281.5' rx='281.5' ry='274.5' fill='%23FF00FF'/%3E%3C/g%3E%3Cg filter='url(%23filter2_f_605_10249)'%3E%3Cellipse cx='745' cy='315.5' rx='372' ry='298.5' fill='%23FF8A00'/%3E%3C/g%3E%3Cg filter='url(%23filter3_f_605_10249)'%3E%3Cellipse cx='719.5' cy='-156' rx='365.5' ry='356' fill='url(%23paint2_radial_605_10249)'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_f_605_10249' x='-83' y='-176' width='1751' height='1751' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10249'/%3E%3C/filter%3E%3Cfilter id='filter1_f_605_10249' x='341' y='-283' width='1143' height='1129' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='145' result='effect1_foregroundBlur_605_10249'/%3E%3C/filter%3E%3Cfilter id='filter2_f_605_10249' x='73' y='-283' width='1344' height='1197' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10249'/%3E%3C/filter%3E%3Cfilter id='filter3_f_605_10249' x='54' y='-812' width='1331' height='1312' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_605_10249'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_605_10249' x1='1440.26' y1='-34.8486' x2='993.719' y2='968.4' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF8A00'/%3E%3Cstop offset='1' stop-color='%23FF00FF'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_605_10249' x1='1815.95' y1='-18.6046' x2='1645.59' y2='813.222' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.28766' stop-color='%23FF8A00'/%3E%3Cstop offset='1' stop-color='%23FF00FF'/%3E%3C/linearGradient%3E%3CradialGradient id='paint2_radial_605_10249' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(718.151 -154.686) rotate(89.7821) scale(354.689 364.154)'%3E%3Cstop stop-color='%23FF00FF'/%3E%3Cstop offset='0.734375' stop-color='%23FF8A00'/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E");
        //   opacity: 0;
        // }

        // .m-cta-big:hover .bg-2 {
        //   animation: animation 1.65s ease-in-out 1ms infinite;
        // }

        // .m-cta-big:hover .bg-3 {
        //   animation: animation 1.65s ease-in-out 3s infinite;
        // }

        .rich-text-container--intro ::slotted(*) {
          font-size: 1.05rem;
        }
      }
    `,
  ];

  @property()
  id: string;

  @property({attribute: 'src'})
  imgSrc: string;

  @property({attribute: 'alt'})
  imgAlt: string;

  @property({attribute: 'use-grid'})
  useGrid: boolean;

  @property({attribute: 'big-title', type: Boolean})
  hasBigTitle: boolean;

  protected render(): unknown {
    return html`
      ${this.useGrid ? html`
        <section id="${ifDefined(this.id)}" class="m-cta-big m-cta-big--with-grid ${this.hasBigTitle ? 'title-big' : ''}">
          <div part="container" class="container">
            <div class="wrapper bg-gradient">
              ${this.imgSrc ?
                html`
                  <div class="image-background">
                    <img src="${this.imgSrc}" alt="${this.imgAlt}" loading="lazy" width="1080">
                  </div>
                ` :
                html`
                  <span class="bg bg-1"></span>
                `
              }
              <webs-grid-row justify="center">
                <webs-grid-column sm="10" md="9">
                  <div class="content">
                    <div class="text-content">
                      <slot name="title"></slot>
                      <div class="rich-text-container--intro">
                        <slot></slot>
                      </div>
                    </div>
                    <div class="cta-actions">
                      <slot name="action"></slot>
                    </div>
                  </div>
                  <webs-grid-column>
              </webs-grid-row>
            </div>
          </div>
        </section>
      ` : html`
        <section id="${ifDefined(this.id)}" class="m-cta-big ${this.hasBigTitle ? 'title-big' : ''}">
          <div class="wrapper bg-gradient">
            ${this.imgSrc ?
              html`
                <div class="image-background">
                  <img src="${this.imgSrc}" alt="${this.imgAlt}" loading="lazy" width="1080">
                </div>
              ` :
              html`
                <span class="bg bg-1"></span>
<!--                <span class="bg bg-abs bg-2"></span>-->
<!--                <span class="bg bg-abs bg-3"></span>-->
              `
            }
            <div part="container" class="container">
              <div class="content">
                <div class="text-content">
                  <slot name="title"></slot>
                  <div class="rich-text-container--intro">
                    <slot></slot>
                  </div>
                </div>

                <div class="cta-actions">
                  <slot name="action"></slot>
                </div>
              </div>
            </div>
        </section>
      `}
    `;
  }
}
